import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Subject, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoginService } from '../login/shared/login.service';
import { environment } from './../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../login/shared/login.service";
var MorningMeetingService = /** @class */ (function () {
    function MorningMeetingService(https, authenticate) {
        this.https = https;
        this.authenticate = authenticate;
        this.morning_meeting_notif = new Subject();
    }
    MorningMeetingService.prototype.getMorningMeeting = function (staffid, showAll, tz_offset) {
        var headers = new HttpHeaders({
            'Authorization': this.authenticate.getToken(),
            'Content-Type': 'application/json'
        });
        var params = new HttpParams();
        params = params.append('staffId', staffid.toString());
        params = params.append('showAll', showAll.toString());
        params = params.append('tz_offset', tz_offset.toString());
        return this.https.get(environment.SERVER_URL + "/morning_meeting", { headers: headers, params: params })
            .pipe(catchError(this.handleError));
    };
    // downloadAttendanceStatus(from, to, staffid: any): Observable<Blob>  {
    //   let params = new HttpParams();
    //   params = params.append('staff_id', staffid);
    //   params = params.append('from', from);
    //   params = params.append('to', to);
    //   let headers = new HttpHeaders({
    //     'Authorization': this.authenticate.getToken(),
    //     'Content-Type': 'application/json'
    //   })
    //   return this.https.get(`${environment.SERVER_URL}/attendance_status/download`, { headers: headers, params: params, responseType: 'blob' })
    //     .pipe(
    //       catchError(err => throwError(err))
    //     );
    // }
    MorningMeetingService.prototype.updateMorningMeeting = function (id, comment, absent) {
        var headers = new HttpHeaders({
            'Authorization': this.authenticate.getToken(),
            'Content-Type': 'application/json'
        });
        var body = {
            id: id,
            comment: comment,
            absent: absent
        };
        return this.https.put(environment.SERVER_URL + "/morning_meeting", body, { headers: headers })
            .pipe(catchError(this.handleError));
    };
    MorningMeetingService.prototype.handleError = function (error) {
        var errMsg;
        if (error) {
            var body = error || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return observableThrowError(errMsg);
    };
    MorningMeetingService.ngInjectableDef = i0.defineInjectable({ factory: function MorningMeetingService_Factory() { return new MorningMeetingService(i0.inject(i1.HttpClient), i0.inject(i2.LoginService)); }, token: MorningMeetingService, providedIn: "root" });
    return MorningMeetingService;
}());
export { MorningMeetingService };
